import React from "react";

type Props = {
  width: number;
  height: number;
  className?: string;
};

const ChevronRotateSvg: React.FC<Props> = ({
  width,
  height,
  className,
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 12"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M10.0029 11.2746C10.2725 11.2746 10.5281 11.1639 10.716 10.9553L19.719 1.60856C19.8929 1.43 20 1.21365 20 0.947642C20 0.414578 19.5958 0 19.0627 0C18.8117 0 18.5607 0.108192 18.3868 0.271725L9.42792 9.55831H10.5721L1.60856 0.271725C1.43931 0.108192 1.20437 0 0.947636 0C0.409901 0 0 0.414578 0 0.947642C0 1.21365 0.111781 1.43468 0.285669 1.6132L9.29438 10.96C9.48793 11.1685 9.72288 11.2746 10.0029 11.2746Z"
        fill="black"
      />
      <title>chevron down</title>
    </svg>
  );
};

export { ChevronRotateSvg };
